import { closePopup, openPopup } from '@/popups/popup';

export function popupAlreadyRegister() {
  $('.already-register-success').on('click', (e) => {
    e.preventDefault();

    closePopup($('#popup-already-register'));
    openPopup($('#event-register'));
  });
}
